const messages = {
    gb: {
        global: {
            currency_format: '£{0}',
            currency_symbol: '£',
        },
    },
};

export default messages;